<template>
  <div>
    <StockPurchaseOrderListDiscrepancy
      :statusId="statusId"
      :pageTitle="pageTitle"
    >
    </StockPurchaseOrderListDiscrepancy>
  </div>
</template>
<script>
//General
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";

import { permissionMixin } from "@/core/mixins/permissionMixin.js";

import StockPurchaseOrderListDiscrepancy from "@/modules/stock/components/purchase-orders/StockPurchaseOrderListDiscrepancy.vue";

import AuthService from "@/core/services/auth.service";

import _ from "lodash";
export default {
  name: "StockPurchaseOrderListDiscrepancyPage",
  mixins: [permissionMixin],
  data() {
    return {
      statusId: 4,
      pageTitle: this.$t("LIST_DISCREPANCY_STOCK_PURCHASE_ORDERS")
    };
  },
  components: { StockPurchaseOrderListDiscrepancy },
  watch: {},
  mounted() {
    let vm = this;
    this.$store.dispatch(SET_BREADCRUMB, [
      { title: "Discrepancy Stock Purchase Orders List" }
    ]);

    AuthService.refreshUserData();
  },
  computed: {},
  methods: {}
};
</script>
